import { useMutation } from 'react-query'
import axios from 'axios'

const ENDPOINT = `/api/rh-warranty`

export const usePostApplication = (config = {}) =>
  useMutation((data) => axios.post(`${ENDPOINT}`, data), config)
